import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import i18next from "i18next";

const TempPrivacy = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const htmlContent = t("temp-privacy-policy-html");

  return (
    <div>
      <Meta
        title={t("temp-privacy-policy-title")}
        description={t("temp-privacy-policy-title")}
        lang={lang}
      />
      <Navbar />
      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/protection-of-personal-data.e5691f2e.jpg")}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div
                className="c-caption-section"
                style={{ color: "#fff", textAlign: "center" }}
              >
                {t("sustainability")}
              </div>
              <h1 className="c-caption-header">
                {t("temp-privacy-policy-title")}
              </h1>
            </div>
          </div>
        </div>
        <div
          className="c-container"
          style={{
            display: "flex",
            flexDirection: "column",
            paddingTop: "3rem",
            paddingBottom: "3rem",
          }}
        >
          <div
            className="privacy-html-content"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </div>
      </div>
    </div>
  );
};

export default TempPrivacy;
